import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/layout/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Clientes from './pages/Clientes';
import Leads from './pages/Leads';
import Projetos from './pages/Projetos';
import MapaProjetos from './pages/MapaProjetos';
import DocumentoCemig from './pages/DocumentoCemig';
import Geral from './pages/Geral';
import PreVendaLead from './pages/PreVendaLead';
import PreVendaMeusLeads from './pages/PreVendaMeusLeads';
import PreVendaKanban from './pages/PreVendaKanban';
import PreVendaUltimasAtualizacoes from './pages/PreVendaUltimasAtualizacoes';
import Agenda from './pages/Agenda';
import Controle from './pages/Controle';
import GeradorProposta from './pages/GeradorProposta';
import Financeiro from './pages/Financeiro';
import Funcionarios from './pages/Funcionarios';
import JornadaCliente from './pages/JornadaCliente';
import CadastrarCliente from './pages/CadastrarCliente';
import VendedorPerformance from './pages/VendedorPerformance';
import GeradorContrato from './pages/GeradorContrato';
import Documentos from './pages/Documentos';
import NotaEngenheiro from './pages/NotaEngenheiro';
import NotaVendedor from './pages/NotaVendedor';
import Kits from './pages/Kits';
import SimuladorParcelas from './pages/SimuladorParcelas';
import CustosComercial from './pages/CustosComercial';
import CustosContabil from './pages/CustosContabil';
import ResumoFinanceiro from './pages/ResumoFinanceiro';
import Monitoramento from './pages/Monitoramento';

function PrivateRoute({ children, allowed }) {
  const { user, loading } = useAuth();
  if (loading) return <div style={{ display:'flex', justifyContent:'center', alignItems:'center', height:'100vh', background:'#0f1117', color:'#f6c90e', fontSize:18 }}>Carregando...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (allowed && !allowed.includes(user.perfil_acesso)) return <Navigate to="/" replace />;
  return children;
}

function AppRoutes() {
  const { user, loading } = useAuth();
  if (loading) return null;
  return (
    <Routes>
      <Route path="/login" element={!user ? <Login /> : <Navigate to="/" replace />} />
      <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
        <Route index element={<Dashboard />} />
        {/* Universal */}
        <Route path="geral"             element={<Geral />} />
        <Route path="mapa"              element={<MapaProjetos />} />
        <Route path="jornada/:clienteId" element={<JornadaCliente />} />
        <Route path="vendedor/:id/performance" element={<PrivateRoute allowed={[1,2,3]}><VendedorPerformance /></PrivateRoute>} />
        {/* Pré Venda */}
        <Route path="pre-venda"         element={<PrivateRoute allowed={[1,4]}><PreVendaLead /></PrivateRoute>} />
        <Route path="pre-venda-leads"   element={<PrivateRoute allowed={[1,4]}><PreVendaMeusLeads /></PrivateRoute>} />
        <Route path="pre-venda-kanban"  element={<PrivateRoute allowed={[1,4]}><PreVendaKanban /></PrivateRoute>} />
        <Route path="pre-venda-atualizacoes" element={<PrivateRoute allowed={[1,4]}><PreVendaUltimasAtualizacoes /></PrivateRoute>} />
        {/* Vendedor / Pós Venda / Instalador (Engenheiro removido) */}
        <Route path="agenda"            element={<PrivateRoute allowed={[1,2,3,5,6,7]}><Agenda /></PrivateRoute>} />
        <Route path="controle"          element={<PrivateRoute allowed={[1,2,3,4,5,6]}><Controle /></PrivateRoute>} />
        <Route path="clientes"          element={<PrivateRoute allowed={[1,2,3,5,6,7]}><Clientes /></PrivateRoute>} />
        <Route path="gerador-proposta"  element={<PrivateRoute allowed={[1,2,3]}><GeradorProposta /></PrivateRoute>} />
        <Route path="gerador-contrato"  element={<PrivateRoute allowed={[1,2,3]}><GeradorContrato /></PrivateRoute>} />
        <Route path="cadastrar-cliente" element={<PrivateRoute allowed={[1,2,3]}><CadastrarCliente /></PrivateRoute>} />
        {/* Documentos unificado */}
        <Route path="documentos"        element={<PrivateRoute allowed={[1,2,3,5,6]}><Documentos /></PrivateRoute>} />
        <Route path="documento-cemig"   element={<PrivateRoute allowed={[1,2,3]}><DocumentoCemig /></PrivateRoute>} />
        {/* Chefe */}
        <Route path="financeiro"        element={<PrivateRoute allowed={[1]}><Financeiro /></PrivateRoute>} />
        <Route path="projetos"          element={<PrivateRoute allowed={[1,3]}><Projetos /></PrivateRoute>} />
        <Route path="funcionarios"      element={<PrivateRoute allowed={[1]}><Funcionarios /></PrivateRoute>} />
        <Route path="nota-engenheiro"   element={<PrivateRoute allowed={[1]}><NotaEngenheiro /></PrivateRoute>} />
        <Route path="nota-vendedor"     element={<PrivateRoute allowed={[1,2,3,4]}><NotaVendedor /></PrivateRoute>} />
        <Route path="kits"              element={<PrivateRoute allowed={[1,2,3,5,7]}><Kits /></PrivateRoute>} />
        <Route path="simulador-parcelas" element={<PrivateRoute allowed={[1,2,3]}><SimuladorParcelas /></PrivateRoute>} />
        <Route path="custos-comercial"    element={<PrivateRoute allowed={[1]}><CustosComercial /></PrivateRoute>} />
        <Route path="custos-da-empresa"  element={<PrivateRoute allowed={[1]}><CustosContabil /></PrivateRoute>} />
        <Route path="resumo-financeiro"  element={<PrivateRoute allowed={[1]}><ResumoFinanceiro /></PrivateRoute>} />
        <Route path="monitoramento"      element={<PrivateRoute allowed={[1]}><Monitoramento /></PrivateRoute>} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}
